import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HradminRoutingModule } from './hradmin-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxEditorModule } from 'ngx-editor';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HradminRoutingModule,
    FormsModule,ReactiveFormsModule,
    NgxEditorModule 
  ]
})
export class HradminModule { }
